<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('tools.partners.compensation_rates.product_group')"
            :is-required="true"
            :error="errors.product_group"
        >
            <DInput
                id="product_group"
                v-model="form.product_group"
                :placeholder="__('tools.partners.compensation_rates.product_group')"
                :is-valid="isFormFieldValid('product_group')"
                :disabled="form.id !== null"
                maxlength="10"
            />
        </DFormRow>
        <DFormRow
            :label="__('tools.partners.compensation_rates.distributor_id')"
            :is-required="true"
            :error="errors.distributor_id"
        >
            <DInput
                id="distributor_id"
                v-model="form.distributor_id"
                :placeholder="__('tools.partners.compensation_rates.distributor_id')"
                :is-valid="isFormFieldValid('distributor_id')"
                :disabled="form.id !== null"
                maxlength="10"
            />
        </DFormRow>
        <DFormRow
            :label="__('tools.partners.compensation_rates.compensation_rate')"
            :is-required="true"
            :error="errors.compensation_rate"
        >
            <DInput
                id="compensation_rate"
                v-model="form.compensation_rate"
                :placeholder="__('tools.partners.compensation_rates.compensation_rate')"
                :is-valid="isFormFieldValid('compensation_rate')"
                type="number"
                min="0"
            />
        </DFormRow>
        <DFormRow
            :label="__('tools.partners.compensation_rates.valid_from')"
            :is-required="false"
            :error="errors.valid_from"
        >
            <DDateFormatInput
                id="valid_from"
                v-model="form.valid_from"
                format="YYYY-MM-DD"
                type="date"
                :is-valid="isFormFieldValid('valid_from')"
                :placeholder="__('tools.partners.compensation_rates.valid_from')"
            />
        </DFormRow>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'CompensationRateForm',
    props: {
        partnerCompensationRate: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                id: this.partnerCompensationRate?.id ?? null,
                product_group: this.partnerCompensationRate?.product_group ?? null,
                distributor_id: this.partnerCompensationRate?.distributor_id ?? null,
                compensation_rate: this.partnerCompensationRate?.compensation_rate ?? null,
                valid_from: this.partnerCompensationRate?.valid_from ?? null
            })
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        }
    }
}
</script>

<style scoped>

</style>
